import { ID } from '../../utils/codecUtils';
import { workspaceSchema } from './../models/workspace.schema';

export const get = (workspaceId: ID) => {
  return {
    endpoint: `/workspaces/${workspaceId}`,
    method: 'GET',
    responseSchema: workspaceSchema,
  } as const;
};
